'use client'
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import Modal from "react-bootstrap/Modal";
import {Col, Container, Form, Row} from "react-bootstrap";
import SvgButton from "@/components/SvgButton";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import axios from "axios";
import Button from "@/components/Button";
import {Black, black, hover, white} from "@/styles/globalStyleVars";

const PopupForms =({
                    show,
                    handleClose,
                    no_img,
                    item,
                    title,
                    description,
                    data,
                    subtitle,
                    img, about, form_tag, form_id
                }) => {
    const popupData = data;
    const menuIconB=`<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.8536 12.1464C12.6583 11.9512 12.3417 11.9512 12.1464 12.1464C11.9512 12.3417 11.9512 12.6583 12.1464 12.8536L19.2947 20.0018L12.1464 27.1501C11.9512 27.3454 11.9512 27.662 12.1464 27.8572C12.3417 28.0525 12.6583 28.0525 12.8536 27.8572L20.0018 20.7089L27.1501 27.8572C27.3454 28.0525 27.662 28.0525 27.8572 27.8572C28.0525 27.662 28.0525 27.3454 27.8572 27.1501L20.7089 20.0018L27.8572 12.8536C28.0525 12.6583 28.0525 12.3417 27.8572 12.1464C27.662 11.9512 27.3454 11.9512 27.1501 12.1464L20.0018 19.2947L12.8536 12.1464Z" fill="black"/>
</svg>`


    const [IsSubmitting, setIsSubmitting] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setIsSubmitting(false);
        }, 300);
    }, []);

    const {register, handleSubmit, formState, reset} = useForm({mode: "all"});
    const {errors, isSubmitSuccessful, isSubmitting} = formState;


    //--- form submit
    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    // // form submit
    const [reg, setReg] = useState({
        name: "",
        department: "",
        phone: "",
        email: "",
        msg: "",
    });


    const onSubmit = async (data) => {
        setIsSubmitting(true); // Show spinner
        try {
            const formData = new FormData();
            formData.append("_wpcf7_unit_tag", "form_" + form_tag ? form_tag : "e99210b");
            formData.append("your-name", data?.name);
            formData.append("email", data?.email);
            formData.append("phone", data?.phone);
            formData.append("your-message", data?.message);

            const response = await axios.post(
                `https://cms.ups-bd.com/wp-json/contact-form-7/v1/contact-forms/${form_id ? form_id : '253'}/feedback`,
                formData
            );
            if (response.status === 200) {
                success(response?.data?.message);
                reset(); // Reset form fields
            } else {
                error("Failed to submit form. Please try again later.");
            }
        } catch (err) {
            error(
                err?.message
                    ? err?.message
                    : "Failed to submit form. Please try again later."
            );
        } finally {
            setIsSubmitting(false); // Hide spinner
        }
    };

    const onError = (errors) => {
        // setToastShown(false); // Reset toast shown state on new submission attempt
        const firstError = Object.values(errors)[0];
        error(firstError.message);
    };


    return (
        (<StyledModal>
            <Modal
                show={show}
                item={item}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="gph_modal popup-version-one popup drop-requirments"
            >
                <div className="main_scroll">
                    <Modal.Body>
                        <Container>
                            <Row className={'for-close'}>
                                <Col md={12} className={'d-flex justify-content-between align-items-center'}>
                                    <h3>Drop your Requirements</h3>
                                    <div onClick={handleClose} className="close-area ">
                                        <SvgButton svg={menuIconB}
                                                   width={40}
                                                   height={40}
                                        />
                                    </div>
                                </Col>

                            </Row>
                        </Container>
                        <Container>
                            <Row>
                                <Col md={{span: 8, offset: 2}} className="modal-data d-flex">
                                        <Form className={'form'}>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Control
                                                    className={
                                                        formState?.errors?.name?.message
                                                            ? "has-error form-control-lg"
                                                            : "form-control-lg"
                                                    }
                                                    {...register("name", {
                                                        required: "Enter your full name",
                                                        pattern: {
                                                            value: /^[A-Za-z ]+$/,
                                                            message: "Name must contain only letters",
                                                        },
                                                    })}
                                                    type="text"
                                                    placeholder="Name*"
                                                    disabled={isSubmitting}
                                                />
                                                {errors.name && (
                                                    <span className="error-message form-error">
                      {errors.name.message}
                    </span>
                                                )}
                                            </Form.Group>

                                            <div className="phoneEmail">
                                                <div className="form-group">
                                                    <Form.Group controlId="formBasicPhone">
                                                        <Form.Control
                                                            className={
                                                                formState?.errors?.phone?.message
                                                                    ? "has-error form-control-lg"
                                                                    : "form-control-lg"
                                                            }
                                                            {...register("phone", {
                                                                required: {
                                                                    value: true,
                                                                    message: "Enter your phone number",
                                                                },
                                                                pattern: {
                                                                    value: /^01[0-9]{9}$/,
                                                                    message: "Enter a valid 11 digit phone number",
                                                                },
                                                            })}
                                                            type="number"
                                                            placeholder="Phone / WhatsApp*"
                                                            disabled={isSubmitting}
                                                        />
                                                        {errors.phone && (
                                                            <span className="error-message form-error">
                        {errors.phone.message}
                      </span>
                                                        )}
                                                    </Form.Group>
                                                </div>
                                                <div className="form-group">
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Control
                                                            className={
                                                                formState?.errors?.email?.message
                                                                    ? "has-error form-control-lg"
                                                                    : "form-control-lg"
                                                            }
                                                            {...register("email", {
                                                                required: {
                                                                    value: false,
                                                                    message: "Enter a valid email address",
                                                                },
                                                                pattern: {
                                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                    message: "Enter a valid email address",
                                                                },
                                                            })}
                                                            type="email"
                                                            placeholder="Email"
                                                            disabled={isSubmitting}
                                                        />
                                                        {errors.email && (
                                                            <span className="error-message form-error">
                        {errors.email.message}
                      </span>
                                                        )}
                                                    </Form.Group>
                                                </div>

                                            </div>

                                            <div className="form-group">
                                                <Form.Group controlId="formBasicPhone">
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={4}
                                                        className={
                                                            formState?.errors?.message?.message
                                                                ? "has-error form-control-lg"
                                                                : "form-control-lg"
                                                        }
                                                        {...register("message", {
                                                            required: {
                                                                value: false,
                                                                message: "Enter your Message",
                                                            },
                                                        })}
                                                        // type="textarea"
                                                        placeholder="Message Details"
                                                        disabled={isSubmitting}
                                                    />
                                                    {errors.message && (
                                                        <span className={"form-error error-message"}>
                      {errors.message?.message}
                    </span>
                                                    )}
                                                </Form.Group>
                                            </div>
                                            <div
                                                style={{width: "fit-content"}}
                                                onClick={handleSubmit(onSubmit, onError)}
                                            >
                                                <Button text={'Submit Message'} src={"javascript:void(0)"}
                                                        border={`1px`}
                                                        borderColor={`${Black}`}
                                                        hoverBackground={`${hover}`}
                                                        color={`${Black}`}
                                                        hoverColor={white}
                                                        padding={'10px 20px'}
                                                />
                                            </div>
                                        </Form>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                </div>
            </Modal>
        </StyledModal>)
    );
};


const StyledModal = styled.div`

  .modal-dialog {
    margin: 0;
  }
 
  h5{
    color: #EDEEEF !important;
  }

  .footer__social {
    .col-sm-4 {
      min-width: 100%;
      justify-content: flex-start !important;

      &:nth-of-type(1) {
        display: none;
      }
      &:nth-last-of-type(1) {
        //display: none !important;
      }
    }
  }
  
`;


export default React.memo(PopupForms);
